module.exports = __webpack_public_path__ + "static/mission-923015c899599074fa6621ac070afcb8.png";